module.exports = __webpack_public_path__ + "static/media/kal_road.146fd852.jpg";